import { render, staticRenderFns } from "./TicketsDesktopHeaderToolbar.vue?vue&type=template&id=faf50440&"
import script from "./TicketsDesktopHeaderToolbar.vue?vue&type=script&lang=js&"
export * from "./TicketsDesktopHeaderToolbar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports